import React from 'react'

import { Form, Col } from '_zari/core'

const AnticipoInfoFormGroup = ({ iValue }) => {
  return (
    <>
      <Form.Group>
        <Form.Label text='ANTICIPO :' md={3} alignRightAt='md' />
        <Col md={9}>
          <Form.OnlyText text={iValue.join(',  ')} />
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(AnticipoInfoFormGroup)
